import {PermissionScope} from "./permission-scope.enum";
import {PermissionGrant} from "./permission-grant.enum";

export class PermissionItem {

  public readonly scope: PermissionScope;
  public readonly grant: PermissionGrant;

  constructor(scope: PermissionScope, grant: PermissionGrant) {
    this.scope = scope;
    this.grant = grant;
  }

  public get read(): boolean {
    return this.write || this.grant === PermissionGrant.R;
  }

  public get write(): boolean {
    return this.delete || this.grant === PermissionGrant.RW;
  }

  public get delete(): boolean {
    return this.grant === PermissionGrant.RWD;
  }

  public isAllow(grant: PermissionGrant): boolean {
    switch (grant) {
      case PermissionGrant.R:
        return this.read;
      case PermissionGrant.RW:
        return this.write;
      case PermissionGrant.RWD:
        return this.delete;
    }
    return false;
  }
}
